import React from 'react';
import { Filter } from 'lucide-react';

const EventFilters = ({
  selectedType,
  onTypeChange,
  selectedDistance,
  onDistanceChange,
  distanceOptions,
  selectedRegion,
  onRegionChange,
}) => {
  const eventTypes = [
    { id: 'ALL', label: 'Все события' },
    { id: 'RUN', label: 'Бег' },
    { id: 'TRI', label: 'Триатлон' },
    { id: 'SWIM', label: 'Плавание' },
  ];

  const eventRegions = [
    { id: 'ALL', label: 'Все старты' },
    { id: 'LOCAL', label: 'Локальные' },
    { id: 'INTL', label: 'Международные' },
  ];

  const hasDistanceFilter = selectedDistance !== 'ALL';
  const hasTypeFilter = selectedType !== 'ALL';
  const hasRegionFilter = selectedRegion !== 'ALL';
  const hasActiveFilters = hasDistanceFilter || hasTypeFilter || hasRegionFilter;

  const resetFilters = () => {
    onTypeChange('ALL');
    onRegionChange('ALL');
    onDistanceChange('ALL');
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <div className="flex items-center justify-between gap-2 mb-4">
        <h2 className="text-base font-semibold text-gray-900 flex items-center gap-2">
          <Filter className="w-4 h-4" />
          Фильтры
        </h2>
        {hasActiveFilters && (
          <button
            type="button"
            onClick={resetFilters}
            className="px-3 py-1.5 bg-white border border-gray-300 rounded-lg text-xs font-medium text-gray-700 hover:bg-gray-50"
          >
            Сбросить
          </button>
        )}
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Тип события
          </label>
          <select
            value={selectedType}
            onChange={(e) => onTypeChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
          >
            {eventTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Регион
          </label>
          <select
            value={selectedRegion}
            onChange={(e) => onRegionChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
          >
            {eventRegions.map((region) => (
              <option key={region.id} value={region.id}>
                {region.label}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Дистанция
          </label>
          <select
            value={selectedDistance}
            onChange={(e) => onDistanceChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4897d2] focus:border-transparent"
          >
            <option value="ALL">Все дистанции</option>
            {distanceOptions.map((distance) => (
              <option key={distance} value={distance}>
                {distance}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default EventFilters;
